import React from 'react';
import DataTableWithButton from '../../shared/component/dataTable/DataTableWithButton';
import {getActualOrderAmountTone, getActualOrderAmountHighlightColor} from './PurchaseRequisitionActualOrderUtils';

const CHEAPER_COST_HIGHLIGHT = '#e81123';

const STATUS_LABELS = {
    MATCHED: 'Matched',
    SHORT: 'Short delivery',
    OVER: 'Over delivery',
    MISSING: 'Missing on DN',
    UNEXPECTED: 'Not on PO'
};

export default class PurchaseRequisitionItemDataTable extends DataTableWithButton {
    getMoneyCellHighlight = (rowData, column) => {
        if (this.props.highlightCheaperCost === false) {
            return null;
        }
        if (column.field === 'currentCost' && rowData.cheaperCostAvailable === true) {
            return CHEAPER_COST_HIGHLIGHT;
        }
        if (column.field === 'actualOrderAmount') {
            return getActualOrderAmountHighlightColor(rowData);
        }
        return null;
    };

    longNameBody = (rowData) => {
        const text = rowData?.longName || rowData?.itemName || '';
        return (
            <span
                style={{whiteSpace: 'normal', wordBreak: 'break-word'}}
                title={text}
            >
                {text}
            </span>
        );
    };

    actualOrderHighlightBody = (rowData) => {
        const value = rowData?.actualOrderAmount;
        const display = value == null || value === '' ? '—' : value;
        const tone = getActualOrderAmountTone(rowData);
        if (!tone) {
            return <span>{display}</span>;
        }
        return (
            <span className={`pr-actual-qty pr-actual-qty--${tone}`} title={this.getActualOrderTitle(tone)}>
                {display}
            </span>
        );
    };

    getActualOrderTitle = (tone) => {
        if (tone === 'over-max') {
            return 'Actual order amount exceeds Max Stock';
        }
        if (tone === 'over-capacity') {
            return 'Current stock + actual order exceeds Max Stock';
        }
        if (tone === 'below-recommended') {
            return 'Actual order amount is below Recommended Qty';
        }
        if (tone === 'above-recommended') {
            return 'Actual order amount is above Recommended Qty';
        }
        return '';
    };

    getCompareStatusLabels = () => this.props.compareStatusLabels || STATUS_LABELS;

    getDeliveryCompareTone = (matchStatus) => {
        if (matchStatus === 'SHORT' || matchStatus === 'MISSING' || matchStatus === 'UNEXPECTED') {
            return 'short';
        }
        if (matchStatus === 'OVER') {
            return 'over';
        }
        return null;
    };

    deliveryCompareStatusBody = (rowData) => {
        const status = rowData?.matchStatus;
        const labels = this.getCompareStatusLabels();
        const label = labels[status] || status || '';
        const tone = this.getDeliveryCompareTone(status);
        if (!tone) {
            return <span>{label}</span>;
        }
        return <span className={`dn-compare-chip dn-compare-chip--${tone}`}>{label}</span>;
    };

    deliveryCompareWarningBody = (rowData) => {
        const warning = rowData?.warning || '';
        const tone = this.getDeliveryCompareTone(rowData?.matchStatus);
        if (!warning) {
            return <span>—</span>;
        }
        if (!tone) {
            return <span title={warning}>{warning}</span>;
        }
        return (
            <span className={`dn-compare-warning dn-compare-warning--${tone}`} title={warning}>
                {warning}
            </span>
        );
    };

    deliveryCompareDamagedBody = (rowData) => {
        const damaged = Number(rowData?.damagedQty);
        const display = rowData?.damagedQty == null || rowData?.damagedQty === '' ? 0 : rowData.damagedQty;
        const isAlert = !Number.isNaN(damaged) && damaged > 0;
        return (
            <span className={isAlert ? 'dn-compare-damaged dn-compare-damaged--alert' : ''}>
                {display}
            </span>
        );
    };
}
